import { createContext, useState, useContext } from "react";
import UnitContext from "./unit-context";

const ConvertContext = createContext({
  convert: (selectedMeasurement, toggleBool, ingredients) => {},
  convertFromImperialToMetric: (ingredients) => {},
  convertFromMetricToImperial: (ingredients) => {},
})


export function ConvertContextProvider(props) {
  const unitContext = useContext(UnitContext)

  function roundToTwoDecimals(number) {
    return parseFloat(Math.round(number * 100) / 100);
  }

  function convertToKilogramsOrGrams(measurement, ingredient) {
    const kilograms = measurement.convertTo.kilograms(ingredient.amount)
    const grams = measurement.convertTo.grams(ingredient.amount)

    if(kilograms >= 1.0) {
      ingredient.amount = Math.round(kilograms * 10) / 10
      ingredient.unit = unitContext.metric.kilograms.symbol
    } else {
      ingredient.amount = Math.round(grams)
      ingredient.unit = unitContext.metric.grams.symbol
    }
  }

  function convertToLitersOrMilliliters(measurement, ingredient) {
    const liters = measurement.convertTo.liters(ingredient.amount)
    const milliliters = measurement.convertTo.milliliters(ingredient.amount)
    if(liters >= 1.0) {
      ingredient.amount = roundToTwoDecimals(liters)
      ingredient.unit = unitContext.metric.liters.symbol
    } else {
      ingredient.amount = parseFloat(Math.round(milliliters))
      ingredient.unit = unitContext.metric.milliliters.symbol
    }
  }

  function convertFromImperialToMetric(ingredients) {
    ingredients.forEach(function(ingredient, index) {
      if (ingredient.unit === unitContext.imperial.pounds.symbol) {
        convertToKilogramsOrGrams(unitContext.imperial.pounds, ingredient)
      }
      else if (ingredient.unit === unitContext.imperial.ounces.symbol) {
        convertToKilogramsOrGrams(unitContext.imperial.ounces, ingredient)
      }
      else if(ingredient.unit === unitContext.imperial.gallons.symbol) {
        convertToLitersOrMilliliters(unitContext.imperial.gallons, ingredient)
      }
      else if(ingredient.unit === unitContext.imperial.fluidOunces.symbol) {
        convertToLitersOrMilliliters(unitContext.imperial.fluidOunces, ingredient)
      }
      else if(ingredient.unit === unitContext.imperial.pints.symbol) {
        convertToLitersOrMilliliters(unitContext.imperial.pints, ingredient)
      }
      else if(ingredient.unit === unitContext.imperial.quarts.symbol) {
        convertToLitersOrMilliliters(unitContext.imperial.quarts, ingredient)
      }
    }); 
  }

  function convertToPoundsOrOunces(measurement, ingredient) {
    const pounds = measurement.convertTo.pounds(ingredient.amount)
    const ounces = measurement.convertTo.ounces(ingredient.amount)
    if(pounds >= 1.0) {
      ingredient.amount = roundToTwoDecimals(pounds)
      ingredient.unit = unitContext.imperial.pounds.symbol
    } else {
      ingredient.amount = roundToTwoDecimals(ounces)
      ingredient.unit = unitContext.imperial.ounces.symbol
    }
  }

  function convertToGallonsOrQuartsOrPintsOrFluidOunces(measurement, ingredient) {
    const gallons = measurement.convertTo.gallons(ingredient.amount)
    const quarts = measurement.convertTo.quarts(ingredient.amount)
    const pints = measurement.convertTo.pints(ingredient.amount)
    const fluidOunces = measurement.convertTo.fluidOunces(ingredient.amount)
    if(gallons >= 1.0) {
      ingredient.amount =roundToTwoDecimals(gallons)
      ingredient.unit = unitContext.imperial.gallons.symbol
    }
    else if(pints >= 1.0) {
      ingredient.amount = roundToTwoDecimals(pints)
      ingredient.unit = unitContext.imperial.pints.symbol
    }
    else if(quarts >= 1.0) {
      ingredient.amount = roundToTwoDecimals(quarts)
      ingredient.unit = unitContext.imperial.quarts.symbol
    }
    else {
      ingredient.amount = roundToTwoDecimals(fluidOunces)
      ingredient.unit = unitContext.imperial.fluidOunces.symbol
    }
  }

  function convertFromMetricToImperial(ingredients) {
    ingredients.forEach(function(ingredient, index) {
      if(ingredient.unit === unitContext.metric.kilograms.symbol) {
        convertToPoundsOrOunces(unitContext.metric.kilograms, ingredient)
      }
      else if(ingredient.unit === unitContext.metric.grams.symbol) {
        convertToPoundsOrOunces(unitContext.metric.grams, ingredient)
      }
      else if(ingredient.unit === unitContext.metric.liters.symbol) {
        convertToGallonsOrQuartsOrPintsOrFluidOunces(unitContext.metric.liters, ingredient)
      }
      else if(ingredient.unit === unitContext.metric.milliliters.symbol) {
        convertToGallonsOrQuartsOrPintsOrFluidOunces(unitContext.metric.milliliters, ingredient)
      }
    });
  }

  function convert(selectedMeasurement, toggleBool, ingredients) {
    if(toggleBool) {
      if(selectedMeasurement === "metric") {
        convertFromImperialToMetric(ingredients);
      } else if(selectedMeasurement === "imperial") {
        convertFromMetricToImperial(ingredients);
      }
    }
  }

  const context = {
    convert: convert,
    convertFromImperialToMetric: convertFromImperialToMetric,
    convertFromMetricToImperial: convertFromMetricToImperial,
  };

  return(
    <ConvertContext.Provider value={context}>
      {props.children}
    </ConvertContext.Provider> 
  )
}

export default ConvertContext;